import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['loggedIn']),
    ...mapState({
      user: state => state.user || {
        
      }
    }),
  },
  async created() {
    try {
      await this.fetchUser();
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  },
  
  methods: {
    ...mapActions(['fetchUser', 'logoutAction']),
    async logout() {
      try {
        await this.logoutAction();
        this.$router.push({ name: 'default' });
      } catch (error) {
        console.error('Error logging out:', error);
      }
    },
  }
}